import React, { useState, useImperativeHandle, useRef, forwardRef } from "react";
import MemberOrdersDetailsDialog from "./MemberOrdersDetailsDialog";

/**
 * 會員收費明細對話框管理器
 *
 * 功能：
 * - 統一管理會員收費明細對話框的開關與資料
 * - 使用命令模式與管理器模式設計
 * - 遵循標準 Dialog PROP 格式：open, onClose, sourceData, refresh
 *
 * @component
 * @param {Object} props - 組件屬性
 * @param {Object} ref - 組件引用
 * @returns {JSX.Element} 會員收費明細對話框管理器
 */
const MemberOrderDetailsDialogBox = forwardRef((props, ref) => {
	const [open, setOpen] = useState(false);
	const sourceDataRef = useRef({});
	const refreshRef = useRef(null);

	/**
	 * 執行刷新操作
	 */
	const doRefresh = () => {
		if (refreshRef.current && typeof refreshRef.current === "function") {
			refreshRef.current();
		}
	};

	/**
	 * 關閉對話框
	 */
	const handleClose = () => {
		refreshRef.current = null;
		sourceDataRef.current = {};
		setOpen(false);
	};

	useImperativeHandle(
		ref,
		() => {
			return {
				/**
				 * 開啟會員收費明細對話框
				 * @param {Object} sourceData - 資料來源（包含 memberID 及可選的會員資訊：clubName, memberName, cellPhone, memberNo）
				 * @param {Function} refreshFn - 刷新函數（可選）
				 */
				openDetailsDialog: (sourceData = {}, refreshFn = () => {}) => {
					sourceDataRef.current = {
						cycleOrderID: sourceData?.cycleOrderID,
						memberID: sourceData?.memberID,
						clubName: sourceData?.clubName,
						memberName: sourceData?.memberName,
						cellPhone: sourceData?.cellPhone,
						memberNo: sourceData?.memberNo,
					};
					refreshRef.current = refreshFn;
					setOpen(true);
				},
				/**
				 * 關閉對話框
				 */
				close: () => handleClose(),
			};
		},
		[]
	);

	return <MemberOrdersDetailsDialog open={open} onClose={handleClose} sourceData={sourceDataRef.current} refresh={doRefresh} />;
});

export default MemberOrderDetailsDialogBox;
